import { Box, useTheme } from '@mui/material';
import styled from '@emotion/styled';

export const StyledTabsContainer = styled(Box)(() => {
  const { tokens } = useTheme();
  const { semantic } = tokens;

  return { paddingBottom: semantic.iconSize['2xl'].value }; //48px};
});
